<template>
  <div>
    <h1 class="is-size-1 has-text-centered m-b-5">{{ $t("message.welcome") }}</h1>

    <div class="columns">
      <div
        class="column"
      >Lorem ipsum, dolor sit amet consectetur adipisicing elit. Impedit alias quas ducimus corrupti architecto facilis recusandae laboriosam rem vitae iusto non quae quis repellendus reiciendis cumque, laudantium sapiente delectus explicabo odit aut veritatis necessitatibus neque! Quasi necessitatibus maxime consectetur quos soluta tempora itaque minima eius. Modi, ipsam tenetur dolores voluptates aliquid, asperiores et adipisci porro natus odio earum laudantium neque placeat ad officiis ducimus illo, facilis aliquam recusandae nam animi culpa? Voluptas, laudantium aut, aperiam ipsa culpa nulla quo ea neque eaque voluptatem eos. Fugit doloribus labore atque enim consequuntur suscipit dolorem repellat, ipsa quas et laborum minus unde aut ipsam fuga earum, ipsum, officia hic reiciendis aspernatur quam ad? Minima totam, voluptatibus magni ex expedita quasi excepturi in officia repudiandae unde quae libero, maxime officiis, accusantium provident sed dolorum voluptates ullam voluptatem! Quia et, excepturi odit exercitationem quaerat libero aliquid inventore tenetur asperiores magnam velit eius sint. Voluptatibus, cum ipsa unde maiores numquam vero facilis distinctio similique doloribus assumenda modi corrupti, cumque placeat quae inventore veritatis iure quaerat hic neque culpa, incidunt repudiandae! Laboriosam rem architecto voluptatem aut veniam, fugit libero, voluptatibus iusto quidem aperiam sapiente, adipisci voluptatum dolor ratione sed quos. Eius consequatur harum sint ipsa? Nemo, odio!</div>
      <div class="column is-one-third">
        <div>
          <h3 class="is-size-3">{{ $t("form.email_contacts") }}</h3>
          <form @submit.prevent="onSubmit" class="m-t-5">
            <div class="columns" v-for="(email, i) in emails" :key="i">
              <div class="column">
                <field-input
                  :value.sync="email.email"
                  type="email"
                  :name="'email-'+i"
                  required
                  :vvas="$t('form.email')"
                />
              </div>
              <div class="column is-narrow" v-if="emails.length > 1">
                <button type="button" @click="removeEmail(i)" class="button is-danger">
                  <i class="mdi mdi-minus"></i>
                </button>
              </div>
            </div>

            <div class="field m-t-5">
              <div class="control is-clearfix">
                <button type="button" @click="addNewEmail" class="button is-success">
                  <div class="icon is-small">
                    <i class="mdi mdi-plus"></i>
                  </div>
                  <span>{{ $t("form.add") }}</span>
                </button>
                <button
                  class="button is-primary is-pulled-right"
                  :class="{ 'is-loading': formLoading }"
                >{{ $t("form.save") }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  async asyncData({ error, app }) {
    try {
      const { data } = await app.$api.getEmailContacts();
      return {
        emails: data.map(e => {
          return {
            email: e
          };
        })
      };
    } catch (e) {
      error(e);
    }
  },

  data() {
    return {
      emails: [],
      formLoading: false
    };
  },

  methods: {
    async onSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;
      this.formLoading = true;
      try {
        const { data } = await this.$api.updateEmailContacts(
          this.emails.map(e => {
            return {
              email: e.email.trim()
            };
          })
        );
        this.$toast.success(this.$t("message.success"));
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      }
      this.formLoading = false;
    },

    addNewEmail() {
      this.emails.push({ email: "" });
    },

    removeEmail(i) {
      this.emails = this.emails.filter((e, ind) => ind !== i);
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/nuxt/pages/office/index.vue